export default __webpack_public_path__ + "static/media/charts_preview.5a588eec.jpg";